<template>
  <div class="pc-compare-table">
    <div class="pc-compare-container">
      <!-- 行优先布局：每一行包含左侧标题 + 右侧所有产品的对应数据 -->
      <div class="table-row" v-for="(col, rowIndex) in column" :key="rowIndex">
        <!-- 左侧固定列标题 -->
        <div class="fixed-column-cell"  :class="{ 'center': col.is_center }">
          <div>{{col.label}}</div>
        </div>

        <!-- 右侧可滚动的产品数据 -->
        <div
            class="scrollable-products-wrapper"
        >
          <div class="product-cell" v-for="(item, pIndex) in list" :key="pIndex":style="{backgroundColor: item.compare_color}">
            <!-- 产品型号行 -->
            <div class="product-name" v-if="rowIndex === 0" >
              <div class="close" @click="removeCompareProduct(pIndex)">
                <img :src="icons.close" alt="">
              </div>
              <div class="image">
                <img :src="item.compare_image"></img>
              </div>
              <div class="title">{{item.cn_name}}</div>
            </div>
            <!-- 分类行 -->
            <div class="category-name" v-else-if="rowIndex === 1" >{{item.compare_category ? item.compare_category.cn_name : '-'}}</div>
            <!-- 参数行 -->
            <template v-else-if="item.parameter">
              <template v-for="parameter in item.parameter">
                <div v-if="parameter.is_check == 1 && parameter.attr_id == col.value">
                  <div class="icon-empty">
                    <img :src="icons.confirm" alt="">
                  </div>
                </div>
                <div class="txt" ref="txtRef" :class="{ 'multiline': isMultiline, 'not-center': !parameter.is_center }" v-else-if="parameter.value && parameter.attr_id == col.value" >{{parameter.value}}</div>
                <div v-else-if="parameter.is_check == 0 && parameter.attr_id == col.value" >
                  <div class="icon-empty">
                    <img :src="icons.empty" alt="">
                  </div>
                </div>
              </template>
            </template>
          </div>
        </div>
        <div class="scrollable-products-wrapper select-wrapper" v-if="rowIndex == 0">
          <el-select v-model="selectedProductId" filterable placeholder="新增产品" clearable popper-class="product-add-dropdown" @change="changeProduct">
            <el-option
                v-for="item in productDic"
                :key="item.id"
                :label="item.cn_name"
                :value="item.id"
                :disabled="existingProductIds.includes(item.id)"
            >
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'pc-compare-table',
  props: {
    column: {
      type: Array,
      default: function () {
        return []
      }
    },
    list: {
      type: Array,
      default: function () {
        return []
      }
    },
    productDic: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      icons:{
        close: process.env.VUE_APP_BASE_URL + '/assets/img/close.png',
        empty: process.env.VUE_APP_BASE_URL + '/assets/img/x.png',
        confirm: process.env.VUE_APP_BASE_URL + '/assets/img/g.png'
      },
      multilineCells: [],
      isMultiline: false,
      selectedProductId: '',
    }
  },
  computed: {
    existingProductIds() {
      return this.list.map(item => item.id);
    }
  },
  mounted() {
    this.checkMultiline();
  },
  updated() {
    this.checkMultiline();
  },
  methods: {
    clearSelectedProductId() {
      this.selectedProductId = '';
    },
    async changeProduct(){
      this.$emit('addCompareProduct', this.selectedProductId)
    },
    removeCompareProduct(index){
      this.$emit('removeCompareProduct', index)
    },
    checkMultiline() {
      const elements = this.$refs.txtRef;
      if (!elements) return;

      this.multilineCells = [];

      elements.forEach((el, index) => {
        if (el && el.$el) {
          console.log(index)
          const domEl = el.$el;
          const lineHeight = parseFloat(getComputedStyle(domEl).lineHeight);
          const height = domEl.clientHeight;

          if (height > lineHeight) {
            this.multilineCells.push(index);
            console.log('this.multilineCells')
            console.log(this.multilineCells)
          }
        }
      });
    }
  }
}

</script>

<style scoped>
.pc-compare-table {
  font-size: 18px;
  width: calc(100% - 277px);
  position: relative;
  overflow-x: auto;
  display: flex;
  margin-left: 277px;
  margin-top: 26px;
  margin-bottom: 65px;
  padding-bottom: 50px;
}

.pc-compare-container {
  min-width: 100%;
  display: inline-block;
  min-height: 200px;
}

/* 每一行 */
.table-row {
  display: flex;
  align-items: stretch; /* 关键：让所有子元素高度一致 */
}

/* 左侧固定列标题单元格 */
.fixed-column-cell {
  position: sticky;
  left: 0;
  z-index: 8;
  width: 172px;
  min-width: 172px;
  padding: 15px 10px;
  box-sizing: border-box;
  font-weight: 500;
  display: flex;
  align-items: flex-start;
  background-color: #ffffff;
}

.fixed-column-cell.center {
  align-items: center;
}

.fixed-column-cell > div {
  width: 100%;
  text-align: left;
}

/* 右侧产品数据容器 */
.scrollable-products-wrapper {
  display: flex;
  //flex: 1;
}

/* 单个产品单元格 */
.product-cell {
  width: 317px;
  margin-left: 23px;
  padding: 15px 10px;
  box-sizing: border-box;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  color: #5d5f5f;
  font-size: 16px;
}

.product-cell .image {
  width: 100%;
}
.product-cell .image img {
  display: block;
  width: 100%;
}
/* 产品型号样式 */
.product-name {
  font-weight: bold;
  font-size: 18px;
  width: 100%;
  padding-top: 30px;
}

/* 分类样式 */
.category-name {
  font-size: 16px;
  width: 100%;
}

/* 参数值样式 */
.scrollable-products-wrapper .product-cell .txt {
  white-space: pre-wrap;
  word-break: break-word;
  width: 100%;
}


.scrollable-products-wrapper .product-cell .txt.not-center {
  text-align: left;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 首行圆角 - 固定列 */
.table-row:first-child .fixed-column-cell {
}

/* 首行圆角 - 产品列 */
.table-row:first-child .product-cell:first-child {
}

/* 末行圆角 - 固定列 */
.table-row:last-child .fixed-column-cell {
}

/* 末行圆角 - 产品列 */
.table-row:last-child .product-cell:last-child {
}

.table-row:first-child .scrollable-products-wrapper .product-cell {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.table-row:last-child .scrollable-products-wrapper .product-cell {
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

.scrollable-products-wrapper .product-cell .product-name .close {
  position: absolute;
  width: 40px;
  right: 0;
  top: 0;
  display: block;
  cursor: pointer;
}

.scrollable-products-wrapper .product-cell .product-name .close img {
  display: block;
  width: 100%;
}

.scrollable-products-wrapper .product-cell .product-name .title {
  margin-top: 10px;
}

.scrollable-products-wrapper .product-cell .icon-empty {
  width: 40px;
}
.scrollable-products-wrapper .product-cell .icon-empty img {
  display: block;
  width: 100%;
}

.scrollable-products-wrapper.select-wrapper{
  margin-left: 68px;
  margin-top: 57px;
}


/* 修改焦点边框颜色 */
.scrollable-products-wrapper >>> .el-input__inner:focus {
  border-color: #e62129; /* 替换为你想要的颜色 */
}


.scrollable-products-wrapper >>> .el-input__inner::-webkit-input-placeholder {
  font-size: 14px; /* 修改为你想要的大小 */
}


/* 修改焦点时的外发光效果 */
.scrollable-products-wrapper >>> .el-input.is-focus .el-input__inner {
  border-color: #e62129;
  //box-shadow: 0 0 0 2px rgba(230, 33, 41, 0.2);
}


</style>

<style>
/* 修改选中项的背景色和文字颜色 - 加强优先级 */
.product-add-dropdown  .el-select-dropdown__item.selected {
  color: #e62129 !important; /* 强制修改文字颜色 */
  background-color: #ffe6e6; /* 替换为你想要的背景色 */
}

/* 修改选中项的hover效果 */
.product-add-dropdown >>> .el-select-dropdown__item.selected.hover,
.product-add-dropdown >>> .el-select-dropdown__item.selected:hover {
  background-color: #ffcccc; /* hover时的背景色 */
  color: #e62129 !important; /* 强制修改hover时的文字颜色 */
}

.scrollable-products-wrapper.select-wrapper .el-select {
  width: 150px;
}
</style>
